import React from 'react';
import { Box, Skeleton } from '@mui/material';

const CollectionItemSkeleton = () => (
  <Box
    className="collection-item"
    sx={{ cursor: 'default', pointerEvents: 'none' }}
  >
    <Skeleton
      variant="rectangular"
      width="100%"
      height={150}
      animation="wave"
      sx={{ borderRadius: '8px', mb: '12px' }}
    />
    <Box className="item-content">
      <Skeleton variant="text" animation="wave" sx={{ fontSize: '1rem' }} width="85%" />
      <Skeleton variant="text" animation="wave" sx={{ fontSize: '1rem' }} width="55%" />
      <Skeleton variant="text" animation="wave" sx={{ fontSize: '0.9rem' }} width="45%" />
    </Box>
  </Box>
);

export default CollectionItemSkeleton;
